import { computed } from '@ember/object';
export default function notSameProperty(propertyOne, propertyTwo) {
  return computed(propertyOne, propertyTwo, function () {
    return this.get(propertyOne) !== this.get(propertyTwo);
  });
}